/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { QueryClient } from 'react-query';
import { useUpdateTagTypeStatusMutation } from 'src/graphql';
import { TRootState } from 'src/store';

type UpdateTagTypeStatusArgs = {
  tagTypeId: string;
  status: string;
  mutationUpdateTagTypeStatus: ReturnType<
    typeof useUpdateTagTypeStatusMutation
  >['mutateAsync'];
  queryClient: QueryClient;
};

export const updateTagTypeStatusAction = createAsyncThunk<
  void,
  UpdateTagTypeStatusArgs,
  { state: TRootState }
>(
  'tagType/TagTypeStatusUpdated',
  async ({
    tagTypeId,
    status,
    mutationUpdateTagTypeStatus,
    queryClient,
  }: UpdateTagTypeStatusArgs) => {
    await mutationUpdateTagTypeStatus({
      parameters: {
        status,
        id: tagTypeId,
      },
    });

    queryClient.invalidateQueries('getOrganisationTagTypes');
    queryClient.invalidateQueries('getOrganisationTags');
  },
);
